import { createNavigation } from '@jd/i18n';

export const { Link, redirect, usePathname, useRouter } = createNavigation({
  locales: ['en', 'pl'] as string[],
  defaultLocale: 'en',
  localePrefix: 'as-needed',
});

type LinkComponent = ReturnType<typeof createNavigation>['Link'];

// Cached per locale so the component identity stays stable across renders;
// a new identity would remount the <a> and swallow in-flight clicks.
const linkComponents = new Map<string, LinkComponent>();

export const getLinkComponent = (locale = 'en') => {
  const cached = linkComponents.get(locale);
  if (cached) return cached;
  const { Link } = createNavigation({
    locales: ['en', 'pl'] as string[],
    defaultLocale: locale,
    localePrefix: 'as-needed',
  });
  linkComponents.set(locale, Link);
  return Link;
};
